import {PageManager} from '@mvps-genesis/bootstrap';
import './STORES.scss';

export default class STORES extends PageManager {

	constructor (pageContext) {
		super(pageContext);

		this.storeLocator();
	}

	storeLocator () {
		const frameId = 'locatoriframe';
		const eventMethod = window.addEventListener ? 'addEventListener' : 'attachEvent';
		const eventer = window[eventMethod];
		const messageEvent = eventMethod === 'attachEvent' ? 'onmessage' : 'message';

		eventer(messageEvent, e => {
			if (e.data && typeof e.data === 'string') {
				if (e.data.indexOf('w2gi:iframeHeightUpdated') !== -1) {
					// eslint-disable-next-line array-element-newline
					const [, dimension1, dimension2] = e.data.split('//');
					this.storeLocatorAutoresize(frameId, dimension1, dimension2);
				}

				if (e.data.indexOf('w2gi:scrollPage') !== -1) {
					const offsets = document.getElementById(frameId).getBoundingClientRect();
					const [destination] = e.data.split('//');

					window.scrollTo(0, destination + offsets.top);
				}
			}
		}, false);
	}

	storeLocatorAutoresize (frameId, newHeight) {
		document.getElementById(frameId).style.height = parseInt(newHeight, 10) + 0 + 'px';
	}
}
